module.exports = __webpack_public_path__ + "img/VAB.b710da01.png";